import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR } from "../../../../../helpers/format";
import { IUsuario } from "../Create/types/types";

interface Props {
  data?: IUsuario | any;
  title: string;
  onClose: () => void;
}

const Info: React.FC<Props> = (props: Props) => {

  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_usuario ? props.data.id_usuario : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Nome
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.nome || '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              CPF
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.cpf || '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              E-mail
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.email || '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Subsistema
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {(() => {
                const groups = Array.isArray(props.data?.grupos_usuarios) ? props.data.grupos_usuarios : (props.data?.grupos_usuarios ? [props.data.grupos_usuarios] : []);
                const subsistemas = groups.map((g: any) => g.grupos?.subsistema).filter(Boolean).join(", ");
                return subsistemas || '---';
              })()}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Grupo
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {(() => {
                 const groups = Array.isArray(props.data?.grupos_usuarios) ? props.data.grupos_usuarios : (props.data?.grupos_usuarios ? [props.data.grupos_usuarios] : []);
                 const groupNames = groups.map((g: any) => g.grupos?.nome).filter(Boolean).join(", ");
                 return groupNames || '---';
              })()}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Ativo
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.ativo ? 'Sim' : 'Não'}
            </span>
          </div>
        </div>
        <div className="w-full grid grid-cols-1 gap-2 gap-y-6 mt-4">
        <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data Modificação
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_historico ? formatDateTimeBR(props.data.data_historico) : '---'}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
